import { useEffect, useRef, useState } from "react";
import { marked } from "marked";
import { Box, Button, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import JoditEditor from "jodit-react";
import CustomDivider from "../utils/CustomDivider";

const EditableMarkdown = ({ content = "", onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [htmlValue, setHtmlValue] = useState("");
  const editorRef = useRef(null);

  useEffect(() => {
    if (!content) return;
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(content);
    setHtmlValue(isHtml ? content : marked.parse(content));
  }, [content]);

  const config = {
    readonly: false,
    toolbarSticky: true,
    toolbarButtonSize: "middle",
    buttons: [
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "ul",
      "ol",
      "link",
      "image",
      "align",
      "undo",
      "redo",
      "hr",
      "eraser",
      "font",        // for font family
      "fontsize",    // for font size
      "brush",       // for text color
      "backcolor",   // for background color
    ],
    uploader: {
      insertImageAsBase64URI: true, // Safe, no backend
    },
    imageDefaultWidth: 300,
    useSplitMode: false, // normal mode
    autoGrow: true,      // automatically grow height as content increases
    minHeight: 300,      // minimum height
    // maxHeight: 1000,     // maximum height (optional)
  };


  return (
    <Box>
      {!isEditing ? (
        <>

          <CustomDivider />
          <div dangerouslySetInnerHTML={{ __html: htmlValue }} />
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button variant="text" startIcon={<EditIcon />} onClick={() => setIsEditing(true)}>
              Tap To Edit Content !!
            </Button>
          </Box>

        </>
      ) : (
        <>
          <JoditEditor
            ref={editorRef}
            value={htmlValue} // controlled value
            config={config}
            tabIndex={1}
            onBlur={(newContent) => setHtmlValue(newContent)}
            onChange={(newContent) => { }}
          />

          <Box sx={{ mt: 2, display: "flex", gap: 1,justifyContent:"end" }}>
            {/* <Button
              variant="contained"
              onClick={() => {
                onSave?.(htmlValue);
                setIsEditing(false);
              }}
            >
              Save
            </Button>

            <Button
              variant="outlined"
              onClick={() => {
                const isHtml = /<\/?[a-z][\s\S]*>/i.test(content);
                setHtmlValue(isHtml ? content : marked.parse(content));
                setIsEditing(false);
              }}
            >
              Cancel
            </Button> */}
            <Button
              variant="outlined"
              onClick={() => {
           
              }}
            >
             Compare
            </Button>

            <Button
              variant="text"
              onClick={() => {
                
              }}
              
            >
             Send FeedBack
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                
              }}
            >
          Save As Draft
            </Button>
            <Button
              variant="gost"
              onClick={() => {
              
              }}
            >
              Publish
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default EditableMarkdown;





export const EditorComponent = () => {
  const editor = useRef(null);
  const [content, setContent] = useState('<p>Start writing...</p>');

  const config = {
    readonly: false,
    height: 400,
    toolbarButtonSize: 'middle',
    buttons: ['bold', 'italic', 'underline', 'link', 'unlink', 'source'],
    uploader: {
      insertImageAsBase64URI: true,
    },
  };

  return (
    <div>
      <JoditEditor
        ref={editor}
        value={content}
        config={config}
        tabIndex={1} // tabIndex of textarea
        onBlur={(newContent) => setContent(newContent)}
        onChange={(newContent) => { }}
      />
      <div style={{ marginTop: '20px' }}>
        <h3>Content:</h3>
        <pre>{content}</pre>
      </div>
    </div>
  );
};







